import React from 'react';

function ContainerW({ children, className = '', ...props }) {
  return (
    <div
      className={`flex w-full bg-white rounded-[4px] ${className}`} // Combina las clases predeterminadas con `className`
      {...props} // Acepta propiedades adicionales como `onClick`
    >
      {children}
    </div>
  );
}

export { ContainerW };